<prf-header-react *ngIf="showHeader" />
<prf-menu-react *ngIf="showMenu" />
<prf-react-main>
  <router-outlet></router-outlet>
</prf-react-main>
<prf-footer-react *ngIf="showFooter" />

<ng-container #b2gNewTools></ng-container>
